import React from 'react';

import Image from 'components/Image';
import NestedLink from 'components/NestedLink';
import SeriesTag from 'components/Series/SeriesTag';
import Typography from 'components/Typography';

import { JourneyFragment } from 'graphql/generated/graphql';

import { useTracking } from 'hooks/useTracking';
import './style.scss';

interface IProps {
  journey: JourneyFragment;
  onClick?: () => void;
}

const SeriesCard = ({ journey, onClick }: IProps) => {
  const { trackContentInteraction } = useTracking();

  return (
    <NestedLink
      className="SeriesCard"
      to={`/journeys/${journey.id}`}
      onClick={() => {
        trackContentInteraction(
          'click',
          'content_journeys_tiles',
          journey.title,
        );
        onClick && onClick();
      }}
    >
      {journey.illustration && (
        <>
          <Image
            src={journey.illustration}
            alt={{ id: 'components.SeriesCard.ContentIllustration.alt' }}
            className={'SeriesCard__content__illustration'}
          />
        </>
      )}
      <div className="SeriesCard__content">
        <Typography variant="h3">{journey.title}</Typography>
        <SeriesTag journey={journey} />
        <Typography variant="small-thin">{journey.description}</Typography>
      </div>
    </NestedLink>
  );
};

export default SeriesCard;
